import { createContext, useState } from 'react';
import api from 'services/api';

export const ConsertoReparoContext = createContext();

export const ConsertoReparoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [consertoReparo, setConsertoReparo] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getConsertoReparo = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: consertoReparo?.filter,
        page: consertoReparo?.page,
        size: consertoReparo?.size,
        order: consertoReparo?.order,
        ...payload,
      });
      setConsertoReparo((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ConsertoReparoContext.Provider
      value={{
        consertoReparo,
        getLoading,
        getConsertoReparo,
      }}
    >
      {children}
    </ConsertoReparoContext.Provider>
  );
};
